import optimizely, { Client, OptimizelyUserContext, setLogger, enums } from '@optimizely/optimizely-sdk'

import { OptimizelyEvent } from './events'
import { reportClientError } from 'services/errorReportingService'
import config from 'constants/config'

let client: Client | null
export let userContext: OptimizelyUserContext
let optimizelyResolve
export const optimizelyIsReady = new Promise((resolve) => {
  optimizelyResolve = resolve
})

function getClient() {
  if (!client) {
    client = optimizely.createInstance({
      sdkKey: config.OPTIMIZELY_SDK_KEY,
      datafileOptions: {
        autoUpdate: true,
      },
      eventBatchSize: 10,
      eventFlushInterval: 1000,
    })

    setLogger({
      log: (level, message) => {
        if (level !== enums.LOG_LEVEL.ERROR) return
        reportClientError(new Error(message))
      },
    })
  }

  return client
}

/**
 * Event tracking function
*/
export async function track(event: OptimizelyEvent) {
  const { eventName, tags } = event

  await optimizelyIsReady
  try {
    userContext.trackEvent(eventName, tags)
  } catch (error) {
    console.error(error)
  }
}

/**
 * Init function
*/
export function init(userId: string, attributes: Record<string, any>) {
  const optimizelyClient = getClient()!

  return optimizelyClient.onReady({ timeout: 4000 }).then((result) => {
    if (result.success) {
      optimizelyResolve()
      userContext = optimizelyClient.createUserContext(userId, attributes)!
    }
  })
}
